/* eslint-disable jsx-a11y/anchor-is-valid */
const Header=()=> {
  return (
    <header>
        <nav className="navbar navbar-expand-lg ">
          <div className="container">
            <a href="#" className="text-decoration-none">
              {/* <img
                src="/logo-dark.png"
                className="img-fluid header-logo"
                alt="logo"
              /> */}
            </a>
              <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar"
                >
                  <i className="fa-solid fa-bars i"></i>
              </button>
                <div id="navbar" className="navbar-collapse collapse d-lg-flex justify-content-lg-end">
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="https://foundrylawgroup.com/about/">
                          About
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Team
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Services
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Pricing
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Community
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Blog
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Contact
                        </a>
                      </li>
                    </ul>
              </div>
          </div>
        </nav>
    </header>


  )
}
export default Header